import { showAccessCodeModal, showUsernameModal } from './modals';
import { initializeGame } from '../gameplay/game';
import { initDailyReward } from './dailyReward';
import { hideAppLoader } from './loader';
import { promptDeviceOnLogin } from './devicePicker';

let currentUser = null;

function setUser(user) {
    currentUser = user;
}

function getUser() {
    return currentUser;
}

function displayLoggedInView() {
    const user = getUser();
    console.log('Displaying logged in view');
    document.body.removeAttribute('data-view');
    stopTitleParallax();
    const loggedInView = document.getElementById('logged_in_view');
    loggedInView.style.display = 'block';
    const loggedOutView = document.getElementById('logged_out_view');
    loggedOutView.style.display = 'none';
    document.querySelectorAll('.requires-auth').forEach(elem => elem.style.display = 'block');
    // Hide the lobby logo — the 4-button action grid lives in the center
    // of the screen now and the logo would compete with it.
    const titleContainer = document.querySelector('.title-container');
    if (titleContainer) titleContainer.style.display = 'none';

    const displayName = user.username || user.family_name || "Guest";
    document.getElementById('usernameDisplay').textContent = `${displayName}`;
    console.log(user.username);

    if (user.username) {
        document.getElementById('usernameModal').style.display = 'none';
        try { initializeGame(); } catch (e) { console.error('initializeGame failed:', e); }
        initDailyReward();
        hideAppLoader();
        // Ask the user how they're playing this session (PC / Mobile) —
        // toggles the visible touchscreen button bar during battle.
        try { promptDeviceOnLogin(); } catch (e) { console.error('promptDeviceOnLogin failed:', e); }
    } else {
        // Username modal needs the user to act — get the loader out of the way.
        hideAppLoader();
        showUsernameModal();
    }
}

function displayLoggedOutView() {
    console.log("Displaying logged out view");
    document.body.setAttribute('data-view', 'title');
    const loggedInView = document.getElementById('logged_in_view');
    loggedInView.style.display = 'none';
    const loggedOutView = document.getElementById('logged_out_view');
    loggedOutView.style.display = 'block';
    document.querySelectorAll('.requires-auth').forEach(elem => elem.style.display = 'none');
    const titleContainer = document.querySelector('.title-container');
    if (titleContainer) titleContainer.style.display = '';
    hideAppLoader();
    startTitleParallax();
    console.log("Not signed in yet");
}

// Cursor parallax for the title-screen #title-bg. The home_page art is
// scaled up to 1.06 in CSS so we have a few px of slack to pan into
// without exposing the page background. The pan target follows the
// mouse offset from screen center and the rendered position lerps
// toward it at ~8% per rAF for a smooth, lazy feel. Pointer-coarse
// devices (phones) skip the loop — no hover, no point.
const TITLE_PARALLAX_MAX_PX = 18;
const TITLE_PARALLAX_EASE = 0.08;
let _titleParallaxRAF = null;
let _titleParallaxMove = null;
let _titleParallaxTargetX = 0, _titleParallaxTargetY = 0;
let _titleParallaxCurX = 0, _titleParallaxCurY = 0;

function startTitleParallax() {
    if (typeof window === 'undefined') return;
    if (_titleParallaxRAF) return;
    const bg = document.getElementById('title-bg');
    if (!bg) return;
    // Phones: leave the image centered. No mouse, no point.
    try {
        if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) return;
    } catch (_) {}
    _titleParallaxMove = (e) => {
        const cx = window.innerWidth / 2;
        const cy = window.innerHeight / 2;
        // Invert so the image pans toward where the cursor *was* —
        // i.e. the scene tracks the cursor's gaze, like looking around.
        _titleParallaxTargetX = ((e.clientX - cx) / cx) * -TITLE_PARALLAX_MAX_PX;
        _titleParallaxTargetY = ((e.clientY - cy) / cy) * -TITLE_PARALLAX_MAX_PX;
    };
    window.addEventListener('mousemove', _titleParallaxMove, { passive: true });
    const tick = () => {
        _titleParallaxCurX += (_titleParallaxTargetX - _titleParallaxCurX) * TITLE_PARALLAX_EASE;
        _titleParallaxCurY += (_titleParallaxTargetY - _titleParallaxCurY) * TITLE_PARALLAX_EASE;
        bg.style.transform = `translate(${_titleParallaxCurX.toFixed(2)}px, ${_titleParallaxCurY.toFixed(2)}px) scale(1.06)`;
        _titleParallaxRAF = requestAnimationFrame(tick);
    };
    _titleParallaxRAF = requestAnimationFrame(tick);
}

function stopTitleParallax() {
    if (_titleParallaxRAF) { cancelAnimationFrame(_titleParallaxRAF); _titleParallaxRAF = null; }
    if (_titleParallaxMove) { window.removeEventListener('mousemove', _titleParallaxMove); _titleParallaxMove = null; }
    _titleParallaxTargetX = _titleParallaxTargetY = _titleParallaxCurX = _titleParallaxCurY = 0;
    const bg = document.getElementById('title-bg');
    if (bg) bg.style.transform = 'scale(1.06)';
}

export { displayLoggedInView, displayLoggedOutView, setUser, getUser };
